import { render } from "./FreqYearChange.vue?vue&type=template&id=a07e7348&scoped=true"
import script from "./FreqYearChange.vue?vue&type=script&lang=js"
export * from "./FreqYearChange.vue?vue&type=script&lang=js"

import "./FreqYearChange.vue?vue&type=style&index=0&id=a07e7348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07e7348"]])

export default __exports__